import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";


const AddSubProduct = () => {
  const [formData, setFormData] = useState({});
 
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")

  const SubProductInputsTemplate = [
   
    {
      name: "productname",
      label: "Product Name",
      type: "dropdown",
      required: true,
      options: [],
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "name",
      label: "Name",
      placeholder:"Enter Subproduct Name",
      type: "text",
      required: true,
     validation: { required: true,pattern: /^[A-Za-z\s]*$/, message: "Only Alphabets Are Allowed*"},
      gridClass: "col-lg-4",
    },
    {
      name: "description",
      label: "Description",
      placeholder:"Enter SubProduct Description",
      type: "text",
      required: true,
      validation: { required: true},
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
     
    },
  ];
  const [subProductInputs, setSubProductInputs] = useState(SubProductInputsTemplate);



  useEffect(() => {
    if(formData?.business_partner_id || userType!="superadmin"){
      const fetchProductList = async () => {
        try {
          const response = await axiosInstance.post('/product/ddlproduct', {
            orderBy: 'product_id desc',
            page: 0,
            pageSize: 100,
           
          }, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            }
          });
  
          const productOptions = response.data.data.data.map(product => ({
            label: product.NAME,
            value: product.ID
          }));
  
          setSubProductInputs(prevInputs => prevInputs.map(input => 
            input.name === "productname" ? { ...input, options: productOptions } : input
          ));
        } catch (error) {
          console.error('Error fetching product list:', error);
        }
      };
  
      fetchProductList();
    }
   
  }, [formData?.business_partner_id]);

  const handleFormSubmit = async () => {
    // Validate form before submission
    const errors = {};
    let isValid = true;
  
    console.log("formdata", formData);
  
    // Validation logic
    subProductInputs.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    // If validation fails, display errors
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    // Show confirmation alert
    const confirmation = await showAlert({
      title: "Confirmation",
      text: "Are you sure you want to add Sub-Product?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
  
    if (!confirmation.isConfirmed) return; 
  
    try {
      setLoading(true); 
  
      const payload = {
        product_id: formData?.productname,
        subproduct_name: formData.name,
        subproduct_desc: formData.description,
        status: formData.status === true ? 1 : 0,
      };

      const response = await axiosInstance.post("/subproduct/create", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
  
      console.log("API Response:", response.data);
  
      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Sub-Product added successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/admin/manage-product/sub-product"); 
      }
    } catch (error) {
      console.error("Error submitting form:", error);
  
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      await showAlert({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); 
    }
  };
  
  
  return (
    <>
    <div>
      {loading ? ( 
        <Loader />
      ) : (
      <><div className="backbutton mt-2 mb-2" onClick={() => navigate('/admin/manage-product/product')}>
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Add Sub Product</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter Sub Product Details
                </span>
                <DynamicForm
                  formConfig={subProductInputs}
                  formData={formData}
                  setFormData={setFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3">
                <button onClick={handleFormSubmit} className="submit-btn">
                  Submit
                </button>
              </div></>
          )}
       </div>
    </>
  );
};

export default AddSubProduct;
